import { render } from "./TestReadingWord.vue?vue&type=template&id=79dd4b1d&scoped=true"
import script from "./TestReadingWord.vue?vue&type=script&lang=js"
export * from "./TestReadingWord.vue?vue&type=script&lang=js"

import "./TestReadingWord.vue?vue&type=style&index=0&id=79dd4b1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79dd4b1d"]])

export default __exports__